import React from 'react';
import { ContentRenderer } from '@jetshop/ui/ContentRenderer';
import { components } from '../ContentEditor';

const StartPageContent = ({ items }) => (
  <ContentRenderer items={items} components={components} />
);

export { StartPageContent };
